import { render, staticRenderFns } from "./list-info3.vue?vue&type=template&id=4dbaff68&scoped=true&"
import script from "./list-info3.vue?vue&type=script&lang=js&"
export * from "./list-info3.vue?vue&type=script&lang=js&"
import style0 from "./list-info3.vue?vue&type=style&index=0&id=4dbaff68&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dbaff68",
  null
  
)

export default component.exports